const selectEl = document.getElementById('region-select');

if (selectEl) {
  selectEl.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    let newSearchParams = '';

    event.target.value === ''
      ? params.delete('region')
      : params.set('region', event.target.value);

    if (params.toString() !== '') {
      newSearchParams += '?' + params.toString();
    }

    const anchorTag = '#past-spotlights';
    const newURL = url.origin + url.pathname + newSearchParams + anchorTag;

    window.location.replace(newURL);
  });
}
